/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Range_Meta_DescriptionInputs */

const en_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: grass tees, short game areas, TopTracer, and year-round golf instruction. Iowa's stand-alone practice facility in the capital city.`)
};

const es_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campo de práctica de Des Moines: tees de césped, áreas de juego corto, TopTracer e instrucción todo el año. La instalación de práctica independiente de Iowa en la capital.`)
};

const de_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: Grasabschläge, Kurzspielbereiche, TopTracer und ganzjähriger Golfunterricht. Iowas eigenständige Übungseinrichtung in der Hauptstadt.`)
};

const zh_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`得梅因练习场：草地发球台、短杆区、TopTracer 和全年高尔夫指导。爱荷华州首府的独立练习设施。`)
};

const ar_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ميدان Des Moines Driving Range: منصات ضرب عشبية، ومناطق للعب القصير، وTopTracer، وتعليم الغولف على مدار السنة. منشأة تدريب مستقلة في عاصمة ولاية Iowa.`)
};

const fr_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range : départs en herbe, zones de jeu court, TopTracer et cours de golf toute l'année. Centre de pratique autonome de l'Iowa dans la capitale.`)
};

const vi_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: ô phát bóng trên cỏ, khu tập lối chơi ngắn, TopTracer và hướng dẫn golf quanh năm. Cơ sở luyện tập độc lập của Iowa tại thủ phủ bang.`)
};

const sw_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: sehemu za kupigia mpira kwenye nyasi, maeneo ya short game, TopTracer na mafunzo ya gofu mwaka mzima. Kituo huru cha mazoezi cha Iowa katika mji mkuu wa jimbo.`)
};

const th_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนามไดร์ฟกอล์ฟ Des Moines: จุดตีบนหญ้า พื้นที่ซ้อมเกมสั้น TopTracer และการสอนกอล์ฟตลอดทั้งปี สนามซ้อมอิสระของรัฐไอโอวาในเมืองหลวงของรัฐ`)
};

const bs_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: travnati teeovi, zone kratke igre, TopTracer i golf instrukcija tokom cijele godine. Samostalni objekat za vježbanje u glavnom gradu Iowe.`)
};

const ja_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デモイン・ドライビングレンジ：芝のティー、ショートゲームエリア、TopTracer、通年のゴルフ指導。アイオワ州都のスタンドアローン練習施設。`)
};

const ko_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: 잔디 티, 숏게임 구역, TopTracer, 연중 골프 레슨. 아이오와 주도(州都)의 독립형 연습 시설.`)
};

const pt_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: tees de grama, áreas de jogo curto, TopTracer e aulas de golfe o ano todo. O centro de treino independente de Iowa, na capital do estado.`)
};

const it_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: postazioni su erba, aree per il gioco corto, TopTracer e lezioni di golf tutto l'anno. Il centro di allenamento indipendente dell'Iowa nella capitale dello stato.`)
};

const sv_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: utslagsplatser på gräs, områden för närspel, TopTracer och golfundervisning året runt. Iowas fristående träningsanläggning i delstatens huvudstad.`)
};

const nl_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: afslagplaatsen op gras, short-gamegebieden, TopTracer en het hele jaar door golfles. Het zelfstandige oefencentrum van Iowa in de hoofdstad van de staat.`)
};

const da_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: græsudslagssteder, områder til det korte spil, TopTracer og golfundervisning året rundt. Iowas selvstændige træningsanlæg i delstatens hovedstad.`)
};

const nb_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: utslagsplasser på gress, områder for kortspill, TopTracer og golfundervisning hele året. Iowas frittstående treningsanlegg i delstatshovedstaden.`)
};

const fi_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: nurmilyöntipaikat, lähipelialueet, TopTracer ja golfopetusta ympäri vuoden. Iowan itsenäinen harjoittelukeskus osavaltion pääkaupungissa.`)
};

const pl_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: trawiaste stanowiska, strefy krótkiej gry, TopTracer i nauka gry w golfa przez cały rok. Samodzielny ośrodek treningowy Iowa w stolicy stanu.`)
};

const ru_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: травяные стартовые площадки, зоны короткой игры, TopTracer и круглогодичное обучение гольфу. Самостоятельный тренировочный центр Iowa в столице штата.`)
};

const tr_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: çim atış yerleri, kısa oyun alanları, TopTracer ve yıl boyu golf eğitimi. Iowa'nın eyalet başkentindeki bağımsız antrenman tesisi.`)
};

const hi_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines ड्राइविंग रेंज: घास पर टी, शॉर्ट गेम क्षेत्र, TopTracer और साल भर गोल्फ प्रशिक्षण। राज्य की राजधानी में Iowa की स्वतंत्र अभ्यास सुविधा।`)
};

const id_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: tee rumput, area short game, TopTracer, dan instruksi golf sepanjang tahun. Fasilitas latihan mandiri Iowa di ibu kota negara bagian.`)
};

const ms_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: tee rumput, kawasan permainan pendek, TopTracer dan pengajaran golf sepanjang tahun. Kemudahan latihan tersendiri Iowa di ibu negeri.`)
};

const cs_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: travnatá odpaliště, plochy pro krátkou hru, TopTracer a výuka golfu po celý rok. Samostatné tréninkové zařízení v hlavním městě Iowy.`)
};

const el_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: θέσεις tee σε φυσικό γρασίδι, χώροι για το κοντινό παιχνίδι, TopTracer και μαθήματα γκολφ όλο τον χρόνο. Η αυτόνομη εγκατάσταση εξάσκησης της Iowa στην πρωτεύουσα της πολιτείας.`)
};

const he_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: עמדות חבטה על דשא, אזורי משחק קצר, TopTracer והוראת גולף לאורך כל השנה. מתקן התרגול העצמאי של איווה בעיר הבירה.`)
};

const af_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: grastees, kortspelareas, TopTracer en gholfonderrig dwarsdeur die jaar. Iowa se selfstandige oefenfasiliteit in die hoofstad.`)
};

const hu_range_meta_description = /** @type {(inputs: Range_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines Driving Range: füves elütőhelyek, rövidjáték-területek, TopTracer és egész éves golfoktatás. Iowa önálló gyakorlóközpontja az állam fővárosában.`)
};

/**
* | output |
* | --- |
* | "Des Moines Driving Range: grass tees, short game areas, TopTracer, and year-round golf instruction. Iowa's stand-alone practice facility in the capital city." |
*
* @param {Range_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const range_meta_description = /** @type {((inputs?: Range_Meta_DescriptionInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Range_Meta_DescriptionInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_range_meta_description(inputs)
	if (locale === "de") return de_range_meta_description(inputs)
	if (locale === "zh") return zh_range_meta_description(inputs)
	if (locale === "ar") return ar_range_meta_description(inputs)
	if (locale === "fr") return fr_range_meta_description(inputs)
	if (locale === "vi") return vi_range_meta_description(inputs)
	if (locale === "sw") return sw_range_meta_description(inputs)
	if (locale === "th") return th_range_meta_description(inputs)
	if (locale === "bs") return bs_range_meta_description(inputs)
	if (locale === "ja") return ja_range_meta_description(inputs)
	if (locale === "ko") return ko_range_meta_description(inputs)
	if (locale === "pt") return pt_range_meta_description(inputs)
	if (locale === "it") return it_range_meta_description(inputs)
	if (locale === "sv") return sv_range_meta_description(inputs)
	if (locale === "nl") return nl_range_meta_description(inputs)
	if (locale === "da") return da_range_meta_description(inputs)
	if (locale === "nb") return nb_range_meta_description(inputs)
	if (locale === "fi") return fi_range_meta_description(inputs)
	if (locale === "pl") return pl_range_meta_description(inputs)
	if (locale === "ru") return ru_range_meta_description(inputs)
	if (locale === "tr") return tr_range_meta_description(inputs)
	if (locale === "hi") return hi_range_meta_description(inputs)
	if (locale === "id") return id_range_meta_description(inputs)
	if (locale === "ms") return ms_range_meta_description(inputs)
	if (locale === "cs") return cs_range_meta_description(inputs)
	if (locale === "el") return el_range_meta_description(inputs)
	if (locale === "he") return he_range_meta_description(inputs)
	if (locale === "af") return af_range_meta_description(inputs)
	if (locale === "hu") return hu_range_meta_description(inputs)
	return en_range_meta_description(inputs)
});